// if we add much complexity we might want an OAuthManager instead
import DIContainer from '@components/DependencyInjectionContainer.js';
import { getID } from '@components/Utility/GeneralUtil.js';
import { defer, finalize, interval, of, race, take, throwError } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
export function oAuthPopup(parameters, context) {
    return defer(() => {
        const broadcastId = getID("oauth-broadcast");
        const params = { ...parameters, broadcastid: broadcastId };
        const url = new URL(constructAuthUrl(params));
        url.searchParams.set("popup", "1");
        const popup = window.open(url.toString(), "oauthPopup", "width=600,height=600,resizable=yes,scrollbars=yes");
        if (!popup || popup.closed || typeof popup.closed === "undefined") {
            const errMessage = DIContainer
                .getInstance("CaptionManager")
                .getCaption("system_popup_blocked");
            context.alert({ caption: errMessage, modalStyle: "warning" });
            return throwError(() => new Error(errMessage));
        }
        const broadcast$ = DIContainer
            .getInstance("BroadcastManager")
            .listen(broadcastId)
            .pipe(take(1), mergeMap((resp) => {
            const err = resp?.payload?._error;
            if (err) {
                context.alert({ caption: err, modalStyle: "error" });
                return throwError(() => new Error(err));
            }
            return of(resp);
        }));
        // Error if the user closes the popup before we get a response
        const closed$ = interval(400).pipe(filter(() => popup.closed === true), take(1), mergeMap(() => throwError(() => new Error(DIContainer
            .getInstance("CaptionManager")
            .getCaption("system_popup_closed")))));
        return race(broadcast$, closed$).pipe(finalize(() => {
            try {
                popup.close();
            }
            catch { /* ignore */ }
        }));
    });
}
export function oAuthRedirect(parameters) {
    window.location.href = constructAuthUrl(parameters);
}
function constructAuthUrl(parameters) {
    let action = 'authorizeLogin';
    if (parameters.mode === 'authorize_email') {
        action = 'authorizeEmail';
    }
    const url = new URL(`/oauth/login/${action}`, window.location.origin);
    // Add all defined params
    for (const [key, value] of Object.entries(parameters)) {
        if (value === undefined || value === null)
            continue;
        url.searchParams.set(key, String(value));
    }
    return url.toString();
}
